import { useRef, useEffect } from "react"


export const useInitialFocusRef = (delay?: number) => {
  const boxRef = useRef<HTMLElement|null>(null)
  useEffect(() => {
    setTimeout(() => boxRef.current?.focus(), delay || 0)
  }, [])
  return boxRef
}